import { createStore } from 'vuex'

export default createStore({
  modules: {
    routeTransfer: {
      namespaced: true,
      state: () => ({
        data: null
      }),
      mutations: {
        update(state, data) {
          state.data = data
        },
        reset(state) {
          state.data = null
        }
      }
    }
  },
  state: {
    aes1: '1019E2991V09O17L1019E2991V09O17L',
    aes2: '1019E2991V09O17L',
    param: {
      MGM: null,
      PRO: null,
      SPCCode: null
    },
    activeInfo: {
      // 活動代碼
      activeCode: null,
      // 活動名稱
      activeName: null,
      // 活動Title
      activeTitle: null,
      // LOGO 註記 N: 無, R: 右, L: 左
      logoFlag: null,
      // 活動文案
      activityCopy: null,
      // 注意事項文字
      noticeText: null,
      // QRCode 文案
      qrcodeCopy: null,
      // 轉貼訊息
      repostMessage: null
    },
    isLoading: false
  },
  mutations: {
    setParam(state, data) {
      // 存放參數使用
      state.param = data
    },
    setActiveInfo(state, data) {
      state.activeInfo = data
    },
    showLoading(state) {
      state.isLoading = true
    },
    hideLoading(state) {
      state.isLoading = false
    }
  },
  actions: {

  },
  getters: {
    getActiveInfo: state => {
      return state.activeInfo
    },
    getAes1: state => {
      return state.aes1
    },
    getAes2: state => {
      return state.aes2
    }
  }
})
